import { useSetBusinessDocumentsData } from '@/components/InvoiceReportDetailDrawer/ApplicationContent/hooks/useSetBusinessDocumentsData';
import { useDataChangeReset } from '@/components/InvoiceReportDetailDrawer/hooks/useDataChangeReset';
import {
  AdminInvoiceReportPaymentInfoResponse,
  useGetAdminInvoiceReportPaymentInfo,
} from '@/context/services/admin_invoice_reports/AdminInvoiceReports.service';

export const useAdminInvoiceReportPaymentInfoData = (
  reportId: string
): AdminInvoiceReportPaymentInfoResponse | undefined => {
  const { data } = useGetAdminInvoiceReportPaymentInfo(reportId);
  useDataChangeReset(data);
  useSetBusinessDocumentsData(data);
  return data;
};
